import { useState, useEffect, useMemo } from 'react';
import ReactModal from 'react-modal';
import { IoClose } from 'react-icons/io5';

import Box from 'components/ui/box';
import { useAuth } from 'context/AuthContext';
import { getServerTime } from 'services/dashboard.service';

interface IProps {
  task: any;
  playerInfo: any;
  award?: {
    uau: boolean;
    mandou: boolean;
    valeu: boolean;
  };
  userCodEtapa?: number;
  onSubmit: (task: any) => void;
  onClose: () => void;
}

export default function ModalCod5({ task, playerInfo, award, userCodEtapa, onSubmit, onClose }: IProps) {
  const { user } = useAuth();
  const [active, setActive] = useState<number | undefined>();
  const [loading, setLoading] = useState(false);

  const isVacationManager = useMemo(() => !!playerInfo && !!user && playerInfo._id !== user.extra.id, [playerInfo, user]);

  async function handleSubmit() {
    if (!active || loading) return;

    setLoading(true);

    const updatedData = { ...task };

    if (active === 2) {
      updatedData.multiplicador = 2;
      updatedData.stageNumber = 1;
      updatedData.status = 'concluido';
    } else if (active === 2.1) {
      updatedData.multiplicador = 2;
      updatedData.stageNumber = 2;
      updatedData.status = 'concluido';
    } else if (active === 4) {
      updatedData.multiplicador = 4;
      updatedData.stageNumber = 2;
      updatedData.status = 'concluido';
    } else if (active === 4.1) {
      updatedData.multiplicador = 4;
      updatedData.stageNumber = 3;
      updatedData.status = 'concluido';
    } else if (active === 8) {
      updatedData.multiplicador = 5;
      updatedData.stageNumber = 3;
      updatedData.status = 'valeu';
    } else if (active === 8.1) {
      updatedData.multiplicador = 8;
      updatedData.stageNumber = 3;
      updatedData.status = 'mandou';
    } else if (active === 8.2) {
      updatedData.multiplicador = 16;
      updatedData.stageNumber = 3;
      updatedData.status = 'selo';
      updatedData.evaluator = ['Selo Missão Destaque'];
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: updatedData.status,
        time: { $date: timestamp },
      });
    }

    onSubmit(updatedData);
  }

  function handleCloseModal() {
    onClose();
  }

  function afterOpenModal() {}

  return (
    <>
      <ReactModal
        key={'modal-cod-etapa-5'}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        isOpen={true}
        onAfterOpen={afterOpenModal}
        onAfterClose={handleCloseModal}
        contentLabel="Modal cod_etapa 5"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <>
            <Box className={`w-[90%] lg:w-auto lg:max-w-[600px]`}>
              <button
                className="absolute w-[33px] h-[33px] flex items-center justify-center -top-4 -right-4 button-close bg-slate-blue rounded-full"
                onClick={() => onClose()}
              >
                <IoClose size={23} className="text-white leading-none block m-0 p-0" />
              </button>

              <div className="w-full lg:w-[536px] flex flex-col items-center justify-center space-y-8">
                <h4 className="block text-center text-yellow text-lg font-semibold leading-none">Bonificar realização</h4>
                <p className="block w-full text-alice-blue text-base font-thin">
                  Você pode bonificar todas as entregas que considerar mais relevantes para o seu âmbito de atuação.
                </p>
                <p className="block w-full text-alice-blue text-base font-thin">
                  Selecione a pontuação que deseja enviar a essa entrega.
                </p>

                <ul className="flex flex-wrap w-full space-y-8">
                  <li className="w-1/2 flex items-center justify-center flex-col space-y-4">
                    <button
                      type="button"
                      className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 text-center ${
                        active === 2
                          ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                          : 'text-grey-light border-grey-light'
                      }`}
                      onClick={() => setActive(2)}
                      disabled={loading}
                    >
                      600 pontos
                      <span className="block text-[11px] font-light mt-[6px]">Gerência de Soluções</span>
                    </button>
                    <p className="text-electric-blue font-thin block text-xs">Bonificação no nível 1</p>
                  </li>
                  <li className="w-1/2 flex items-center justify-center flex-col space-y-4 !mt-0">
                    <button
                      type="button"
                      className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 ${
                        active === 2.1
                          ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                          : 'text-grey-light border-grey-light'
                      }`}
                      onClick={() => setActive(2.1)}
                      disabled={loading}
                    >
                      700 pontos
                      <span className="block text-[11px] font-light mt-[6px]">Gerência de Soluções</span>
                    </button>
                    <p className="text-electric-blue font-thin block text-xs">Promover para o nível 2</p>
                  </li>
                  <li className="w-1/2 flex items-center justify-center flex-col space-y-4">
                    <button
                      type="button"
                      className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 ${
                        active === 4
                          ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                          : 'text-grey-light border-grey-light'
                      }`}
                      onClick={() => setActive(4)}
                      disabled={loading}
                    >
                      1.200 pontos
                      <span className="block text-[11px] font-light mt-[6px]">Gerência Executiva</span>
                    </button>
                    <p className="text-electric-blue font-thin block text-xs">Bonificação no nível 2</p>
                  </li>
                  <li className="w-1/2 flex items-center justify-center flex-col space-y-4">
                    <button
                      type="button"
                      className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 ${
                        active === 4.1
                          ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                          : 'text-grey-light border-grey-light'
                      }`}
                      onClick={() => setActive(4.1)}
                      disabled={loading}
                    >
                      1.300 pontos
                      <span className="block text-[11px] font-light mt-[6px]">Gerência Executiva</span>
                    </button>
                    <p className="text-electric-blue font-thin block text-xs">Promover para o nível 3</p>
                  </li>

                  {userCodEtapa && userCodEtapa === 5 && award ? (
                    <>
                      {!!award.valeu && (
                        <li className="w-1/2 flex items-center justify-center flex-col space-y-4">
                          <button
                            type="button"
                            className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 ${
                              active === 8
                                ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                                : 'text-grey-light border-grey-light'
                            }`}
                            onClick={() => setActive(8)}
                            disabled={loading}
                          >
                            1.500 pontos
                            <span className="block text-[11px] font-light mt-[6px]">Diretoria</span>
                          </button>
                          <p className="text-electric-blue font-thin block text-xs">Bonificação Valeu</p>
                        </li>
                      )}
                      {!!award.mandou && (
                        <li className="w-1/2 flex items-center justify-center flex-col space-y-4">
                          <button
                            type="button"
                            className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 ${
                              active === 8.1
                                ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                                : 'text-grey-light border-grey-light'
                            }`}
                            onClick={() => setActive(8.1)}
                            disabled={loading}
                          >
                            2.500 pontos
                            <span className="block text-[11px] font-light mt-[6px]">Diretoria</span>
                          </button>
                          <p className="text-electric-blue font-thin block text-xs">Bonificação Mandou Bem</p>
                        </li>
                      )}
                      {!!award.uau && (
                        <li className="w-1/2 flex items-center justify-center flex-col space-y-4">
                          <button
                            type="button"
                            className={`text-sm leading-none uppercase font-semibold py-3 px-4 rounded-full border-2 ${
                              active === 8.2
                                ? 'text-oxford-blue bg-electric-blue border-electric-blue'
                                : 'text-grey-light border-grey-light'
                            }`}
                            onClick={() => setActive(8.2)}
                            disabled={loading}
                          >
                            5.000 pontos
                            <span className="block text-[11px] font-light mt-[6px]">Diretoria</span>
                          </button>
                          <p className="text-electric-blue font-thin block text-xs">Bonificação UAU</p>
                        </li>
                      )}
                    </>
                  ) : null}
                </ul>

                <button
                  className={`text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none ${
                    !active ? 'opacity-60' : ''
                  }`}
                  onClick={() => handleSubmit()}
                  disabled={!active || loading}
                >
                  ENVIAR PONTUAÇÃO
                </button>
              </div>
            </Box>
          </>
        )}
      />
    </>
  );
}
